module.exports = __webpack_public_path__ + "img/62.2730b7e1.jpg";